import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NavigationRoute, NEEDisplayMode } from '../types/enums';
import { AppState, Account } from '../types/schema';

const initialState: AppState = {
  currentView: NavigationRoute.DASHBOARD,
  selectedYear: new Date().getFullYear(),
  neeDisplayMode: NEEDisplayMode.TOTAL,
  isSidebarCollapsed: false,
  isAuthenticated: false,
  isAdmin: false,
  selectedAccount: null,
  selectedAccountId: undefined,
  availableAccounts: [],
  authView: 'login',
  loginMessage: null,
  isLoading: false,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setAuthentication: (state, action: PayloadAction<boolean>) => {
      state.isAuthenticated = action.payload;
    },
    setIsAdmin: (state, action: PayloadAction<boolean>) => {
      state.isAdmin = action.payload;
    },
    setSelectedAccount: (state, action: PayloadAction<Account | null>) => {
      state.selectedAccount = action.payload;
      state.selectedAccountId = action.payload?.accountId;
    },
    setAvailableAccounts: (state, action: PayloadAction<Account[]>) => {
      state.availableAccounts = action.payload;
    },
    setCurrentView: (state, action: PayloadAction<NavigationRoute>) => {
      state.currentView = action.payload;
    },
    setSelectedYear: (state, action: PayloadAction<number>) => {
      state.selectedYear = action.payload;
    },
    setNEEDisplayMode: (state, action: PayloadAction<NEEDisplayMode>) => {
      state.neeDisplayMode = action.payload;
    },
    toggleSidebar: (state) => {
      state.isSidebarCollapsed = !state.isSidebarCollapsed;
    },
    setAuthView: (state, action: PayloadAction<'login' | 'forgot-password'>) => {
      state.authView = action.payload;
    },
    resetToLogin: (state) => {
      state.authView = 'login';
      state.isAuthenticated = false;
      state.isAdmin = false;
      state.selectedAccount = null;
      state.selectedAccountId = undefined;
      state.currentView = NavigationRoute.DASHBOARD;
    },
    passwordResetSuccess(state) {
      state.isAuthenticated = false;
      state.loginMessage = 'Password successfully set. Please log in with your new password.';
    },
    clearLoginMessage(state) {
      state.loginMessage = null;
    }
  },
});

export const {
  setLoading,
  setCurrentView,
  setSelectedYear,
  setNEEDisplayMode,
  toggleSidebar,
  setAuthentication,
  setIsAdmin,
  setSelectedAccount,
  setAvailableAccounts,
  setAuthView,
  resetToLogin,
  passwordResetSuccess,
  clearLoginMessage,
} = appSlice.actions;

export default appSlice.reducer;
